import { CertificationProvider } from 'app/library/certification-provider/models/certification-provider';
import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';

export class CertificationProviderStateModel extends EntityStateModel<CertificationProvider> {}
